module.exports = lib_ui__rc_upload;